import {NgModule} from '@angular/core';
import {AssignmentOverviewComponent} from './assignment-overview.component';
import {AssignmentRoutingModule} from './assignment.routes';
import {AssignmentService} from './assignment.service';
import {AssignmentFormComponent} from './assignment-form.component';
import {BsDatepickerModule, ModalModule, TabsModule, TooltipModule} from 'ngx-bootstrap';
import {SharedModule} from '../shared/shared.module';
import {ConfigModule} from '../config/config.module';
import {CustomerModule} from '../customer/customer.module';
import {OwnerModule} from '../owner/owner.module';
import {BuildingModule} from '../building/building.module';
import {ContactModule} from '../contact/contact.module';
import {ReportModule} from '../report/report.module';
import {ChannelModule} from '../channel/channel.module';
import {AssignmentCustomerFormComponent} from './assignment-customer-form.component';
import {AssignmentBuildingFormComponent} from './assignment-building-form.component';
import {AssignmentReportFormComponent} from './assignment-report-form.component';
import {ChargeModule} from '../charge/charge.module';
import {WarrantyModule} from '../warranty/warranty.module';

@NgModule({
  declarations: [
    AssignmentOverviewComponent,
    AssignmentFormComponent,
    AssignmentCustomerFormComponent,
    AssignmentBuildingFormComponent,
    AssignmentReportFormComponent
  ],
  exports: [
    AssignmentOverviewComponent,
    AssignmentFormComponent,
    AssignmentCustomerFormComponent,
    AssignmentBuildingFormComponent,
    AssignmentReportFormComponent
  ],
  imports: [
    ConfigModule,
    AssignmentRoutingModule,
    TabsModule.forRoot(),
    SharedModule,
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    ContactModule,
    CustomerModule,
    OwnerModule,
    BuildingModule,
    ChargeModule,
    ReportModule,
    ChannelModule,
    WarrantyModule,
    TooltipModule.forRoot()
  ],
  providers: [
    AssignmentService
  ]
})
export class AssignmentModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/assignment/assignment.module.ts